const mapLink = "https://goo.gl/maps/gs2Fq6waUn5owkFT8";
export const reviewLink =
  "https://www.google.com/maps/place/Kanha+Shanti+Vanam/@17.1752148,78.2189803,15z/data=!4m8!3m7!1s0x3bcbc68ae81e7a79:0x3e82438832073e9d!8m2!3d17.1752148!4d78.2189803!9m1!1b1!16s%2Fg%2F11f3v9r8vh?entry=ttu&g_ep=EgoyMDI1MDEyMC4wIKXMDSoASAFQAw%3D%3D";

export default mapLink;

export const KanhaYoutubeLink = "https://www.youtube.com/embed/jhNPK0r1j3w";

export const nameReg = /^[a-zA-Z ]{2,40}$/;

export const emailReg =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const phoneReg = /^(\+91[\s]?)?[0]?(91)?[6789]\d{9}$/;

export const forestsReg = /^[+]?(\d[^\d]*){10,12}$/;

export const NOT_APPROVED = "not_approved";

export const FREE_ACCOMMODATION = "Free accommodation";
export const PAID_ACCOMMODATION = "Paid accommodation";
export const OWN_ACCOMMODATION = "Having own accommodation";
export const FREE_ACCOMMODATION_VALUE = "free_accommodation_in_kanha";
export const PAID_ACCOMMODATION_VALUE = "paid_accommodation_in_kanha";
export const OWN_ACCOMMODATION_VALUE = "own_accommodation_arrangements";

export const suruchiCafeOrderOnlineLink = "https://suruchicafe.petpooja.com/";
